import { EnemyType, ItemType } from "../../../defines/enums"
import { CombatConfig, Position, RenderConfig } from "../../../defines/types"
import { PathEnemy } from "./path"

export class PathSyncEnemy extends PathEnemy {
  constructor(
    type: EnemyType,
    experience: number,
    combat: CombatConfig,
    position: Position,
    render: RenderConfig,
    name: string,
    fov: number,
    optic?: ItemType
  ) {
    super(type, experience, combat, position, render, name, fov, optic)
  }
}
